import { Box, Container, Grid, Divider } from '@mui/material';
import CounterCard from '../CounterCard';

const VerticalDivider = () => (
    <Divider
        orientation='vertical'
        sx={{ display: { xs: 'none', md: 'block' }, mx: 0 }}
    />
);

const CounterSection = () => {
    return (
        <Box component={'section'} py={3}>
            <Container>
                <Grid container item xs={12} lg={9} sx={{ mx: 'auto' }}>
                    <Grid item xs={12} md={4}>
                        <CounterCard
                            count={70}
                            suffix='+'
                            title='Lorem ipsum'
                            description='Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean ornare.'
                        />
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: { md: 'flex' } }}>
                        <VerticalDivider />
                        <CounterCard
                            count={15}
                            suffix='+'
                            title='Lorem ipsum'
                            description='Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                        />
                        <VerticalDivider />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CounterCard
                            count={4}
                            title='Lorem ipsum'
                            description='Lorem ipsum dolor sit amet, aenean ornare. Consectetur adipiscing elit.'
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default CounterSection;
